export const storeKey = 'store';
export const actionKey = 'lastAction';
